import { createAction } from '@reduxjs/toolkit';

import { TaskActions  } from "../constants/tasks";
import { ActionSuffixes } from "../constants/common/actions";

import ISubscribeTaskListRequest from '../types/tasks/ISubscribeTaskListRequest';

export const createGetTaskListsAction = () => createAction(TaskActions.GetTaskLists);
export const createSetTaskListsAction = () => createAction(TaskActions.TaskLists + ActionSuffixes._Set,
	(value: any) => ({ meta: { prefix: TaskActions.TaskLists }, payload: value }));

export const createSubscribeTaskListAction = () => createAction<ISubscribeTaskListRequest>(TaskActions.SubscribeTaskList);


export const createTaskListsLoadingAction = () => createAction(TaskActions.IsTaskListsLoading + ActionSuffixes._Set,
	(value: boolean) => ({ meta: { prefix: TaskActions.IsTaskListsLoading }, payload: value }));
	
export const createSubscribeLoadingAction = () => createAction(TaskActions.IsSubscribeLoading + ActionSuffixes._Set,
	(value: boolean) => ({ meta: { prefix: TaskActions.IsSubscribeLoading }, payload: value }));
	

